import React, {useContext, useEffect} from "react";
import {ThemeContext} from "../../../providers/themeContext/theme-context.tsx";
import debounce from "lodash/debounce";
import CustomPopup from "../../../components/CustomPopup";
import './MyPuzzlesDialog.css'
import CreateWordDialog from "./CreateWordDialog/CreateWordDialog.tsx";
import {apiService} from "../../../common/utils/http/api-service.ts";
import {IUGCWord} from "../../../common/utils/http/IResponse.ts";
import {ToastContext} from "../../../components/CustomToast/ToastProvider.tsx";
import useLoading from "../../../providers/loadingContext/useLoading.ts";
import HintDialog from "./hintDialog/HintDialog.tsx";
import {GAEvents} from "../../../common/utils/GA4/GAEvents.ts";
import {useMusicContext} from "../../../providers/musicProvider/music-player-context.tsx";

type Props = {
    isOpen: boolean;
    onClose: () => void;
}

// vs player我的游戏历史
const MyPuzzlesDialog: React.FC<Props> = ({isOpen, onClose}) => {
    // 全局音乐provider
    const musicManager = useMusicContext();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    const {addToast} = useContext(ToastContext);
    const {showLoading, hideLoading} = useLoading();
    // 切换按钮
    const [switchIndex, setSwitchIndex] = React.useState<number>(1)
    // 是否打开添加弹窗
    const [isCreateOpen, setIsCreateOpen] = React.useState<boolean>(false)
    // 单词列表
    const [wordList, setWordList] = React.useState<IUGCWord[]>([])
    // 是否打开hint详情弹窗
    const [isHintOpen, setIsHintOpen] = React.useState<boolean>(false)
    // 点击的hint
    const [currentHint, setCurrentHint] = React.useState<string>("")


    useEffect(() => {
        if (isOpen) {
            // GA埋点
            GAEvents.myPuzzleShow()

            getMyMatchedList();
        }
    }, [isOpen]);

    // 获取我的matched列表
    const getMyMatchedList = debounce(async () => {
        try {
            showLoading()
            const response = await apiService.getUGCWordList()
            if (response.code === 200) {
                setWordList(response.data)
            } else {
                addToast({
                    type: "error",
                    message: response.message
                })
            }
        } finally {
            hideLoading()
        }
    }, 100)

    // 切换按钮方法
    const switchBtn = (index: number) => {
        const str = index === 1 ? "Uploaded" : index === 2 ? "Pending" : "Rejected"
        // GA埋点
        GAEvents.myPuzzleModeClick(str)
        musicManager.playButtonSound()
        setSwitchIndex(index)
    }

    // 打开创建单词弹窗
    const handleShowCreateWordDialog = (open: boolean) => {
        // GA埋点
        GAEvents.myPuzzleModeCreateClick()
        musicManager.playButtonSound()
        setIsCreateOpen(open);
        if (!open) {
            setSwitchIndex(2)
            getMyMatchedList()
        }
    }

    const onClickMore = (item: IUGCWord) =>{
        setCurrentHint(item.hint)
        musicManager.playButtonSound()
        setIsHintOpen(true)
    }

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="my-puzzles-dialog-container">
                <img className="my-puzzles-dialog-bg" src={imgUrls.myPuzzlesDialogBg} alt="pic"/>
                {/*标题*/}
                <div
                    className="font-size-16 color-white my-roboto-bold text-center margin-top-11 height-26 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                    My Puzzles
                    <img onClick={onClose} src={imgUrls.closeBtnWhiteUrl} className="exit-close-btn"
                         alt="pic"/>
                </div>
                <div
                    className="width-273 height-521 bg-img-cover-no-repeat-center margin-left-right-auto margin-top-14"
                    style={{backgroundImage: `url(${imgUrls.vsPlayMyMatchCardBg})`}}>
                    <div className="width-233 display-flex-column margin-left-right-auto">
                        <div className="bottom-border-line width-233 display-flex-row height-36 margin-top-10">
                            <div onClick={() => switchBtn(1)}
                                 className={`${switchIndex === 1 ? '' : 'color-grey'} font-size-14 my-roboto-medium width-77 height-36 display-flex-row display-flex-justify-content-center display-flex-align-items-center`}>Uploaded
                            </div>
                            <div onClick={() => switchBtn(2)}
                                 className={`${switchIndex === 2 ? '' : 'color-grey'} font-size-14 my-roboto-medium  width-77 height-36 display-flex-row display-flex-justify-content-center display-flex-align-items-center`}>
                                Pending
                            </div>
                            <div onClick={() => switchBtn(3)}
                                 className={`${switchIndex === 3 ? '' : 'color-grey'} font-size-14 my-roboto-medium  width-77 height-36 display-flex-row display-flex-justify-content-center display-flex-align-items-center`}>
                                Rejected
                            </div>
                        </div>
                        {/*切换指示器*/}
                        <div
                            className={`width-77 my-match-dialog-indicator margin-top-down-2 ${switchIndex === 1 ? 'margin-right-auto' : switchIndex === 2 ? 'margin-left-right-auto' : 'margin-left-auto'}`}/>

                        <div className="height-440 display-flex-column">
                            {/*已上传*/}
                            {switchIndex === 1 && <div className="height-424 overflow-y-auto margin-top-bottom-auto">
                                {
                                    wordList.map((item) => {
                                        if (item.auditStatus === 1) {
                                            return <div key={item.id}
                                                className="display-flex-column display-flex-align-items-center width-233 bg-color-white border-radius-6 margin-bottom-8">
                                                {/*单词卡片*/}
                                                <div className="grid-5-columns grid-gap-3 width-180 margin-top-20">
                                                    {item.word.toUpperCase().split("").map((letter, index) => {
                                                        return (
                                                            <div key={letter + index}
                                                                 className="display-flex-column display-flex-align-items-center display-flex-justify-content-center border-radius-4 width-33 height-40 bg-color-liner-white-green">
                                                                <div
                                                                    className="font-size-27 color-white my-roboto-bold ">{letter}</div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {/*hint提示语*/}
                                                <div onClick={()=> onClickMore(item)}
                                                    className="position-relative margin-top-10 width-206 border-radius-5 bg-color-light-green display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                                                    <div
                                                        className="font-size-14 margin-top-8 margin-bottom-8 margin-left-6 margin-right-6 my-roboto-regular ellipsis-2-line color-black-custom width-193 ">
                                                        {item.hint}
                                                    </div>
                                                    {item.hint.length> 45 && <div
                                                        className="bg-color-light-green height-16 width-30 font-size-11 color-blue position-absolute right-3 position-bottom-3">
                                                        More
                                                    </div>}
                                                </div>
                                                <div
                                                    className="margin-top-10 margin-bottom-10 height-18 width-233 display-flex-row display-flex-space-between">
                                                    <div
                                                        className="margin-left-40 display-flex-row display-flex-align-items-center">
                                                        <img className="width-18 height-18"
                                                             src={item.playCounts > 0 ? imgUrls.ugcPlaysBlueIcon : imgUrls.ugcPlaysGreyIcon}
                                                             alt="pic"/>
                                                        <div
                                                            className="margin-left-4 font-size-14 my-roboto-regular color-grey">{item.playCounts}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="margin-right-40 display-flex-row display-flex-align-items-center">
                                                        <img className="width-18 height-18"
                                                             src={item.likes > 0 ? imgUrls.ugcLikesBlueIcon : imgUrls.ugcLikesGreyIcon}
                                                             alt="pic"/>
                                                        <div
                                                            className="margin-left-4 font-size-14 my-roboto-regular color-grey">{item.likes}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    })}</div>}
                            {switchIndex === 2 && <div className="height-424 overflow-y-auto margin-top-bottom-auto">
                                {
                                    wordList.map((item) => {
                                        if (item.auditStatus === 0) {
                                            return <div id={item.id} key={item.id}
                                                        className="display-flex-column display-flex-align-items-center width-233 bg-color-white border-radius-6 margin-bottom-8">
                                                {/*单词卡片*/}
                                                <div className="grid-5-columns grid-gap-3 width-180 margin-top-20">
                                                    {item.word.toUpperCase().split("").map((letter, index) => {
                                                        return (
                                                            <div key={letter + index}
                                                                 className="display-flex-column display-flex-align-items-center display-flex-justify-content-center border-radius-4 width-33 height-40 bg-color-liner-white-green">
                                                                <div
                                                                    className="font-size-27 color-white my-roboto-bold ">{letter}</div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {/*hint提示语*/}
                                                <div onClick={()=> onClickMore(item)}
                                                    className="position-relative margin-top-10 width-206 border-radius-5 bg-color-light-green display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                                                    <div
                                                        className="font-size-14 margin-top-8 margin-bottom-8 margin-left-6 margin-right-6 my-roboto-regular ellipsis-2-line box-size color-black-custom width-193 ">
                                                        {item.hint}
                                                    </div>
                                                    {item.hint.length> 45 && <div
                                                        className="bg-color-light-green height-16 width-30 font-size-11 color-blue position-absolute right-3 position-bottom-3">
                                                        More
                                                    </div>}
                                                </div>
                                                <div
                                                    className="margin-top-10 margin-bottom-10 height-18 width-233 display-flex-row display-flex-space-between">
                                                    <div
                                                        className="margin-left-40 display-flex-row display-flex-align-items-center">
                                                        <img className="width-18 height-18"
                                                             src={item.playCounts > 0 ? imgUrls.ugcPlaysBlueIcon : imgUrls.ugcPlaysGreyIcon}
                                                             alt="pic"/>
                                                        <div
                                                            className="margin-left-4 font-size-14 my-roboto-regular color-grey">{item.playCounts}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="margin-right-40 display-flex-row display-flex-align-items-center">
                                                        <img className="width-18 height-18"
                                                             src={item.likes > 0 ? imgUrls.ugcLikesBlueIcon : imgUrls.ugcLikesGreyIcon}
                                                             alt="pic"/>
                                                        <div
                                                            className="margin-left-4 font-size-14 my-roboto-regular color-grey">{item.likes}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    })}</div>}
                            {switchIndex === 3 && <div className="height-424 overflow-y-auto margin-top-bottom-auto">
                                {
                                    wordList.map((item) => {
                                        if (item.auditStatus === 2) {
                                            return <div key={item.id}
                                                className="display-flex-column display-flex-align-items-center width-233 bg-color-white border-radius-6 margin-bottom-8">
                                                {/*单词卡片*/}
                                                <div className="grid-5-columns grid-gap-3 width-180 margin-top-20">
                                                    {item.word.toUpperCase().split("").map((letter, index) => {
                                                        return (
                                                            <div key={letter + index}
                                                                 className="display-flex-column display-flex-align-items-center display-flex-justify-content-center border-radius-4 width-33 height-40 bg-grey-custom">
                                                                <div
                                                                    className="font-size-27 color-white my-roboto-bold ">{letter}</div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {/*hint提示语*/}
                                                <div onClick={()=> onClickMore(item)}
                                                    className="position-relative margin-top-10 width-206 border-radius-5 bg-color-grey display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                                                    <div
                                                        className="font-size-14 overflow-y-auto height-31 margin-top-8 margin-bottom-8 margin-left-6 margin-right-6 my-roboto-regular ellipsis-2-line color-black-custom width-193 ">
                                                        {item.hint}
                                                    </div>
                                                    {item.hint.length> 45 && <div
                                                        className="bg-color-light-green height-16 width-30 font-size-11 color-blue position-absolute right-3 position-bottom-3">
                                                        More
                                                    </div>}
                                                </div>
                                                <div
                                                    className="margin-top-10 margin-bottom-10 height-18 width-233 display-flex-row display-flex-space-between">
                                                    <div
                                                        className="margin-left-40 display-flex-row display-flex-align-items-center">
                                                        <img className="width-18 height-18"
                                                             src={item.playCounts > 0 ? imgUrls.ugcPlaysBlueIcon : imgUrls.ugcPlaysGreyIcon}
                                                             alt="pic"/>
                                                        <div
                                                            className="margin-left-4 font-size-14 my-roboto-regular color-grey">{item.playCounts}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="margin-right-40 display-flex-row display-flex-align-items-center">
                                                        <img className="width-18 height-18"
                                                             src={item.likes > 0 ? imgUrls.ugcLikesBlueIcon : imgUrls.ugcLikesGreyIcon}
                                                             alt="pic"/>
                                                        <div
                                                            className="margin-left-4 font-size-14 my-roboto-regular color-grey">{item.likes}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    })}</div>}

                            {/*{*/}
                            {/*    wordList.map((item)=>{*/}
                            {/*        if(item.auditStatus === 1){*/}
                            {/*            return <div className="height-157 width-233 bg-color-white">*/}

                            {/*            </div>*/}
                            {/*        }*/}
                            {/*    })*/}
                            {/*}*/}
                            {/*审核中*/}
                            {/*已被拒*/}
                            {/*没有数据时就显示这个*/}
                            {/*<div className="display-flex-column margin-top-bottom-auto">*/}
                            {/*    <img className="width-153 height-53 margin-left-right-auto "*/}
                            {/*         src={imgUrls.gridNoDataImgUrl}*/}
                            {/*         alt="pic"/>*/}
                            {/*    <div*/}
                            {/*        className="font-size-16 color-grey my-roboto-regular text-center margin-top-8">Create*/}
                            {/*        your own puzzle!*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                        </div>
                    </div>

                </div>
                <div onClick={() => handleShowCreateWordDialog(true)}
                     className="color-white my-roboto-medium font-size-16 border-bottom-radius-16 height-52 bg-color-blue-btn display-flex-row display-flex-align-items-center display-flex-justify-content-center">Create
                </div>
            </div>
            <CreateWordDialog isOpen={isCreateOpen} onClose={() => handleShowCreateWordDialog(false)}/>
            <HintDialog isOpen={isHintOpen} onClose={()=> setIsHintOpen(false)} hintText={currentHint} />
        </CustomPopup>
    )
};

export default MyPuzzlesDialog;